// const backupHostname = 'https://www.polygameforpog.com/gd/ui/swagger-ui.html'
const backupHostname = 'www.axilinongyedianshang011.it.com'
// const backupHostname = '192.168.1.5:8081'
const interfaceName = 'gd'

const getEnv = () => {
  const isLocal = window.location.hostname === 'localhost' || window.location.hostname.indexOf('192.168.') === 0
  const isHttps = window.location.protocol === 'https:'

  const hostname = isLocal ? backupHostname : window.location.hostname

  const origin = `${isHttps ? 'https' : 'http'}://${hostname}`

  const wsOrigin = `${isHttps ? 'wss' : 'ws'}://${hostname}`

  return { hostname, origin, wsOrigin }
}
const { hostname, origin, wsOrigin } = getEnv()

const envConfig = { hostname, origin, wsOrigin, interfaceName }

export default envConfig
